import { Edit } from "lucide-react";
import { useNavigate } from "react-router-dom";

function EditPresentationButton({ presentationId }) {
  const navigate = useNavigate();

  const handlePreview = () => {
    navigate(`/edit-presentation/${presentationId}`);
  };
  return (
    <div>
      <button
        onClick={handlePreview}
        className="px-4 py-2 bg-purple-400 text-sm text-white rounded-lg shadow hover:bg-purple-500 hover:scale-105 transition flex gap-2 items-center"
      >
        <Edit className="w-4 h-4" />
        <span>Edit</span>
      </button>
    </div>
  );
}

export default EditPresentationButton;
